import type { Category } from '../../../models';
import { ValidationErrors } from '../../../models/ValidationErrors';
import type { AssetFilterTypeOptions } from '../../forms/Asset-Editor/AssetFilterTypeOptions';
import type { DateRangeId } from './DateRangeId';

export class SearchForm {
  errors: ValidationErrors = new ValidationErrors([]);

  assetFilterType: AssetFilterTypeOptions[] | null = [];
  excludeAssetFilterTypes: AssetFilterTypeOptions[] | null = [];
  searchText: string = '';
  showRecentlyIngestedAssets: boolean = false;
  showExpiredAssets: boolean = false;
  selectedTags: Array<string> = [];
  selectedCategories: Array<Category> = [];
  includeAudioTranscripts: boolean = false;

  selectedOuIds: string[] = [];

  minDuration: number | null = null;
  maxDuration: number | null = null;

  createdDateStart: string | null = null;
  createdDateRange: { id: DateRangeId; name: string } | null = null;
  ingestDateStart: string | null = null;
  ingestDateRange: { id: DateRangeId; name: string } | null = null;
  expireDateStart: string | null = null;
  expireDateRange: { id: DateRangeId; name: string } | null = null;
}
